export default __webpack_public_path__ + "static/media/avatar_elephant7.c77b4b5a.mp3";